import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource-variable/newsreader/opsz.css";
import "@fontsource-variable/newsreader/opsz-italic.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/dancing-script/600.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
// Prerendered public pages (build/<route>/index.html) hydrate; everything else renders from scratch.
if (container.hasChildNodes()) ReactDOM.hydrateRoot(container, tree, { onRecoverableError: () => {} });
else ReactDOM.createRoot(container).render(tree);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}

// Count real home-screen installs (fires once, from our prompt or the browser's own UI).
window.addEventListener("appinstalled", () => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/event`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event: "app_installed" }), keepalive: true,
    }).catch(() => {});
  } catch (e) { /* ignore */ }
});
